import type { ReactNode } from "react";
import { Card, Group, Stack, Title, useMantineTheme } from "@mantine/core";

const SectionCard = ({
  title,
  icon,
  children,
  highlight = false,
}: {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  highlight?: boolean;
}) => {
  const theme = useMantineTheme();

  return (
    <Card
      shadow="sm"
      p={{ base: "md", sm: "lg" }}
      radius="md"
      withBorder
      bg={highlight ? theme.colors.background_1[0] : undefined}>
      <Stack gap="md">
        <Group
          gap="xs"
          align="center"
          wrap="nowrap">
          {icon}
          <Title
            order={3}
            c={theme.colors.plain_text[0]}>
            {title}
          </Title>
        </Group>
        {children}
      </Stack>
    </Card>
  );
};

export default SectionCard;
